module.exports = __webpack_public_path__ + "img/Argentina.b16f2149.svg";